import type { AreaCatalog } from '../area';
import type { search as en } from '../en/search';

export const search = {
  'search.page.title': 'Suche',
  'search.page.count': { one: '{count} Treffer', other: '{count} Treffer' },
  'search.page.countMore': { one: '{count}+ Treffer', other: '{count}+ Treffer' },
  'search.page.prompt': 'Tippe, um zu suchen, oder füge einen Filter hinzu.',
  'search.page.none': 'Keine Treffer.',
  'search.page.more': 'Mehr Treffer als angezeigt. Grenze die Suche weiter ein.',
  'search.page.pager': 'Seiten der Suchergebnisse',
  'search.controls.placeholder': 'Aufgaben durchsuchen…',
  'search.controls.label': 'Aufgaben durchsuchen',
  'search.controls.narrow': 'Nach Eigenschaft eingrenzen…',
} as const satisfies AreaCatalog<typeof en>;
